import React, { useEffect, useState } from "react";
import {
  makeStyles,
  createStyles,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { getCampCoupons } from "../actions/GenomicsAdminAction";
import { connect } from "react-redux";
import moment from "moment";
import Loader from "../Components/loader/index";
import { useRef } from "react";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: "155px",
      textTransform: "capitalize",
    },
    margin: {
      margin: theme.spacing(1),
    },
    table: {
      maxWidth: "100%",
      margin: "auto",
    },
    center: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    start: {
      display: "flex",
      justifyContent: "flex-start",
    },
    end: {
      display: "flex",
      justifyContent: "flex-end",
    },
    gap: {
      fontSize: "14px",
      margin: "0 -40px 0 40px",
    },
    select: {
      margin: "0 0 0 -8px",
      minWidth: "155px",
      width: "100%",
      height: "40px",
    },
    textFieldGap: {
      padding: "0 10px",
    },
    centerIt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    startIt: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
    },
    checkBoxGap: {
      padding: "0 40px",
    },
    formContorlLabel: {
      padding: "0 0 0 25px",
      margin: "0 0 0 15px",
      color: "rgba(0, 0, 0, 0.54)",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
      padding: "5px",
      textTransform: "capitalize",
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
interface Props {
  centre: any;
  isActive: any;
  getCampCoupons: any;
  campCouponList: any;
  loading: any;
}
const PromotionalCamp: React.FC<Props> = ({
  getCampCoupons,
  campCouponList,
  centre,
  isActive,
  loading,
}) => {
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [centreId, setCentreId] = useState<any>([]);
  const [page, setPage] = useState(0);
  useEffect(() => {
    getCampCoupons();
  }, []);
  useEffect(() => {
    if (centre !== "" && centre !== undefined) {
      getCampCoupons(`center__id=${centre}&is_active=${isActive}`);
    }
  }, [centre, isActive]);
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = campCouponList.links && campCouponList.links.next.split("?")[1];
      getCampCoupons(url);
    } else if (newPage < page) {
      let url =
        campCouponList.links && campCouponList.links.previous.split("?")[1];
      getCampCoupons(url);
    }
    setPage(newPage as number);
  };
  return (
    <Grid container item xs={12}>
      <Paper style={{ width: "100%" }}>
        <TableContainer style={{ maxHeight: "540px" }}>
          {loading ? (
            <Loader />
          ) : (
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Sr. No.</StyledTableCell>
                  <StyledTableCell>Discount Name</StyledTableCell>
                  <StyledTableCell>Discount</StyledTableCell>
                  <StyledTableCell align="center">
                    From Age(Years)
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    To Age(Years)
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Applicable For
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Validity From
                  </StyledTableCell>
                  <StyledTableCell align="center">Validity to</StyledTableCell>
                  <StyledTableCell align="center">Centre Name</StyledTableCell>
                  <StyledTableCell align="center">Test Name</StyledTableCell>
                  <StyledTableCell align="center">
                    Is Coupon Required
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {campCouponList.results &&
                  campCouponList.results.length > 0 &&
                  campCouponList.results.map((val: any, index: any) => {
                    return (
                      <StyledTableRow>
                        <StyledTableCell align="center">
                          {index + 1}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {val?.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {/* {val?.discount_type === "percentage"
                                  ? val?.discount + "%"
                                  : "Rs." + val?.discount} */}
                          {val?.discount + "%"}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {val?.from_age}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {val?.to_age}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {val?.gender}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {moment(val?.valid_from).format(
                            "DD-MM-YYYY, hh:MM A"
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {moment(val?.valid_till).format(
                            "DD-MM-YYYY, hh:MM A"
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {val?.display_name === null
                            ? val?.center
                            : val?.display_name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {val?.packages &&
                            val?.packages.map((list: any, index: any) => {
                              return (
                                <p style={{ display: "inline" }}>
                                  {index > 0 ? <span>,</span> : <span></span>}
                                  {list}
                                </p>
                              );
                            })}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {String(val?.is_active) === "true"
                            ? "Active"
                            : "Disabled"}
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
              </TableBody>
            </Table>
          )}
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[]}
          colSpan={3}
          count={campCouponList.count}
          rowsPerPage={campCouponList.page_size}
          page={page}
          onPageChange={handleChangePage}
        />
      </Paper>
    </Grid>
  );
};

const mapStateToProps = (state: any) => ({
  campCouponList: state.GenomicsAdminReducer.campCouponList,
  loading: state.GenomicsAdminReducer.loading,
});

export default connect(mapStateToProps, {
  getCampCoupons,
})(PromotionalCamp);
